<template>
  <div class="page-home container">
    <data-table
      ref="table"
      class="mt-3"
      title="لیست تاریخچه فعالیت ها"
      uid="table-devices"
      :query="query"
      :options="options"
    >
      <el-table-column
        prop="entityType"
        label="نوع"
        align="center"
        min-width="100"
      >
        <template slot-scope="{ row }">
          <span class="font-weight-bold">
            {{ getEnum(row.entityType, 'entityType') }}
          </span>
          <span
            :class="{
              'pill success_pill':
                getEnumValue(row.action, 'deviceAction') === 'CREATE',
              'pill info_pill':
                getEnumValue(row.action, 'deviceAction') === 'UPDATE',
              'pill danger_pill':
                getEnumValue(row.action, 'deviceAction') === 'DELETE'
            }"
          >
            {{
              getEnum(row.entityType, 'entityType', 'value') === 'DEVICE'
                ? getEnum(row.action, 'deviceAction')
                : getEnum(row.entityType, 'entityType', 'value') === 'USER'
                ? getEnum(row.action, 'userAction')
                : '??'
            }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="createdAt"
        label="تاریخ ایجاد"
        align="center"
        min-width="100"
      >
        <date-time-display
          slot-scope="{ row }"
          :date="row.createdAt"
          class="rounded-md"
          style="min-width:85px"
        />
      </el-table-column>
      <el-table-column
        prop="message"
        label="پیام"
        align="center"
        min-width="300"
        show-overflow-tooltip
      >
        <template slot-scope="{ row }">
          <span class="gray-600">{{ row.message }}</span>
        </template>
      </el-table-column>
    </data-table>
  </div>
</template>

<script>
import ListQuery from '@/graphql/userHistory/UserHistories.gql'
import DateTimeDisplay from '@/components/DateTimeDisplay'
export default {
  name: 'UserHistoriesList',
  components: {
    DateTimeDisplay
  },
  data() {
    return {
      loading: false,
      query: ListQuery,
      dialogVisible: false
    }
  },
  computed: {
    options() {
      let filters = [
        {
          field: 'entityType',
          type: 'select',
          attrs: {
            type: 'text',
            placeholder: 'انتخاب نوع'
          },
          options: this.$enums.getArrayWithKey('entityType')
        }
      ]
      return {
        filters,
        columns: []
      }
    }
  },
  methods: {
    update() {
      this.$refs.table.update()
    },
    getEnum(value, enumName, prop = 'title') {
      return this.$options.filters.enm(value, enumName, prop)
    },
    getEnumValue(value, enumName, prop = 'value') {
      return this.$options.filters.enm(value, enumName, prop)
    }
  }
}
</script>
<style scoped lang="scss">
.gray-600 {
  color: #949494;
}
</style>
